module.exports = __webpack_public_path__ + "static/img/pk1.14ac2e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/pk1.jpg
// module id = IxP9
// module chunks = 2